<div class="x-of-counter">
    <div class="x-of-counter__count -for-current">{{current}}</div>
    <div class="x-of-counter__sep">{{separator}}</div>
    <div class="x-of-counter__count -for-total">{{of}}</div>
</div>